import React, { useContext } from 'react';
import Navigation from '../Navigation/Navigation';
import Logo from './logo.svg'
import { AppContext }  from '../../AppContext'
import { Link } from 'react-router-dom';

function Header() {

    const { isUserLogged, setUserLogged } = useContext(AppContext)

    const handleLogout = () => {
        setUserLogged(false)
        localStorage.clear();
        window.location.replace("https://futebolcardsaude.com.br/acesso");
        return false;
    }

    return (
        <div className="Header">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-12 d-flex align-items-center justify-content-center justify-content-lg-normal d-lg-block col-lg-3">
                        <Navigation />
                        <Link to="/dashboard"><img height="40" alt="FC Saúde" src={Logo} /></Link>
                    </div>
                    <div className="d-none d-lg-block col-lg-9">
                        <nav className="text-end">
                            <ul className="nav nav-inline justify-content-end d-none d-lg-flex">
                                <li className="nav-item"><a className="nav-link active" href="https://futebolcardsaude.com.br/" >Home</a></li>
                                <li className="nav-item"><a className="nav-link" href="https://futebolcardsaude.com.br/#planos" >Planos</a></li>
                                <li className="nav-item"><a className="nav-link" href="https://futebolcardsaude.com.br/#beneficios" >Benefícios</a></li>
                                <li className="nav-item"><a className="nav-link" href="https://futebolcardsaude.com.br/#contato" >Contato</a></li>
                                <li className="nav-item"><a className="nav-link pe-4" href="https://futebolcardsaude.com.br/#planos">Assine agora</a></li>
                                {isUserLogged === 'true' ? (
                                    <li className="nav-item"><a className="btn-default" onClick={() => handleLogout()}>Sair</a></li>
                                ) : (
                                    <li className="nav-item"><a className="btn-default" href="https://futebolcardsaude.com.br/acesso">Entrar</a></li>
                                )}
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;